import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { Home, DollarSign } from "lucide-react";

const RAAD_PHOTO = "https://customer-assets.emergentagent.com/job_raad-realestate/artifacts/xek4wr2m_IMG_8542.jpeg";

export default function HeroSection() {
  return (
    <section className="relative min-h-screen flex items-center overflow-hidden" data-testid="hero-section">
      <div className="absolute inset-0">
        <img
          src="https://images.unsplash.com/photo-1600607687939-ce8a6c25118c?w=1920&q=80"
          alt="Luxury Home"
          className="w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-black via-black/85 to-black/40" />
      </div>

      <div className="relative z-10 max-w-7xl mx-auto px-6 md:px-12 py-32 w-full">
        <div className="grid lg:grid-cols-2 gap-12 items-center">
          <div className="space-y-8 animate-fadeInUp">
            <div className="flex items-center gap-3">
              <div className="h-px w-12 bg-[#D4AF37]" />
              <span className="text-[#D4AF37] uppercase tracking-[0.3em] text-sm font-medium">
                Southern California Real Estate
              </span>
            </div>

            <h1 className="text-5xl sm:text-6xl lg:text-7xl font-black tracking-tighter leading-[0.9]">
              <span className="text-white">Real Estate.</span>
              <br />
              <span className="text-[#D4AF37]">No Bullshit.</span>
              <br />
              <span className="text-white">Just Results.</span>
            </h1>

            <p className="text-xl text-zinc-300 max-w-lg leading-relaxed">
              150+ homes sold. A flawless record of five-star client experiences. Fifteen 
              years of guiding Southern California buyers and sellers with honesty, clarity, and results.
            </p>

            <div className="flex flex-col sm:flex-row gap-4 pt-4">
              <Link to="/buy">
                <Button
                  className="bg-[#D4AF37] text-black hover:bg-[#F3E5AB] rounded-none font-bold uppercase tracking-widest px-8 py-6 text-base"
                  data-testid="hero-buy-button"
                >
                  <Home className="w-5 h-5 mr-2" />
                  Buy With Me
                </Button>
              </Link>
              <Link to="/sell">
                <Button
                  className="bg-transparent border-2 border-white text-white hover:bg-white hover:text-black rounded-none font-bold uppercase tracking-widest px-8 py-6 text-base"
                  data-testid="hero-sell-button"
                >
                  <DollarSign className="w-5 h-5 mr-2" />
                  Sell With Me
                </Button>
              </Link>
            </div>

            <div className="flex items-center gap-6 pt-4">
              <a href="tel:+19092335411" className="text-white hover:text-[#D4AF37] transition-colors">
                <span className="text-2xl font-bold">909.233.5411</span>
              </a>
              <span className="text-zinc-500">|</span>
              <span className="text-zinc-400 text-sm">DRE #01905641</span>
            </div>
          </div>

          <div className="hidden lg:block relative">
            <div className="relative">
              <img
                src={RAAD_PHOTO}
                alt="Raad Shalabi"
                className="w-full max-w-md mx-auto object-cover shadow-2xl"
                data-testid="hero-raad-photo"
              />
              <div className="absolute -bottom-6 -left-6 bg-[#D4AF37] p-6">
                <p className="text-black font-bold text-4xl">150+</p>
                <p className="text-black/70 text-sm uppercase tracking-wider">Homes Sold</p>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 animate-bounce">
        <div className="w-6 h-10 border-2 border-white/30 rounded-full flex justify-center pt-2">
          <div className="w-1.5 h-3 bg-[#D4AF37] rounded-full" />
        </div>
      </div>
    </section>
  );
}
